import { makeStyles } from "@mui/styles";

const useStyles = makeStyles((theme) => ({
  container: {
    borderRadius: 12,
    padding: theme.spacing(3),
    backgroundColor: theme.palette.background.paper,
  },
  uploadArea: {
    borderRadius: 8,
    border: `1px dashed ${theme.palette.divider}`,
    padding: theme.spacing(3),
    marginBottom: theme.spacing(2),
    transition: 'all 0.3s ease',
    minHeight: 160,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  uploadAreaExpanded: {
    minHeight: 200,
    padding: theme.spacing(4),
  },
  uploadInitial: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    textAlign: 'center',
  },
  uploadWithFile: {
    width: '100%',
  },
  dragActive: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    padding: theme.spacing(2),
  },
  filePreview: {
    maxHeight: "80px",
    maxWidth: "120px",
    borderRadius: 4,
    border: `1px solid ${theme.palette.divider}`,
  },
  [theme.breakpoints.down('sm')]: {
    container: {
      padding: theme.spacing(2),
    },
    uploadArea: {
      padding: theme.spacing(2),
    },
    uploadAreaExpanded: {
      padding: theme.spacing(2),
    },
  }
}));

export default useStyles;